import { DocumentsCardsStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DocumentsCard/DocumentsCards.styles.tsx';
import { DocumentCardItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DocumentsCard/DocumentCardItem.tsx';
import { InvestorDocumentRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DocumentsCard/investorDocuments.types.ts';

interface Props {
	rows: InvestorDocumentRow[];
	onPreview: (document: InvestorDocumentRow) => void;
}

export const DocumentsCards = ({ rows, onPreview }: Props) => {
	return (
		<DocumentsCardsStyles>
			{rows.map((row) => (
				<DocumentCardItem key={row.id} document={row} onPreview={onPreview} />
			))}
		</DocumentsCardsStyles>
	);
};
